import { Icon } from './Icon';

/**
 * The surface every panel sits on. One border radius, one border colour, one
 * shadow — defined here so twelve screens cannot end up with eleven of them.
 */

export function Card({ className = '', padded = false, children, ...rest }) {
  return (
    <div
      className={[
        'rounded-xl border border-line bg-surface shadow-card',
        padded ? 'p-4' : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, icon, actions, className = '' }) {
  return (
    <div
      className={`flex items-start justify-between gap-4 border-b border-line px-4 py-3 ${className}`}
    >
      <div className="min-w-0">
        <h3 className="flex items-center gap-2 text-[15px] font-semibold text-ink">
          {icon && <Icon name={icon} size="sm" className="text-ink-3" />}
          <span className="truncate">{title}</span>
        </h3>
        {subtitle && <p className="mt-0.5 text-[13px] text-ink-3">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export function CardBody({ className = '', children }) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}

/** A label/value pair. Used across every detail panel in the app. */
export function DetailRow({ label, value, mono = false, className = '' }) {
  return (
    <div className={`flex items-baseline justify-between gap-4 py-1.5 ${className}`}>
      <dt className="shrink-0 text-[13px] text-ink-3">{label}</dt>
      <dd
        className={`min-w-0 truncate text-right text-[13.5px] text-ink ${
          mono ? 'font-mono text-[12.5px] tabular-nums' : ''
        }`}
      >
        {value ?? '—'}
      </dd>
    </div>
  );
}

export function DetailList({ children, className = '' }) {
  return <dl className={`divide-y divide-line ${className}`}>{children}</dl>;
}
